import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
 	header_data:any;

  constructor(public navCtrl: NavController) {
 		this.header_data={ismenu:true,ishome:false,title:"Fodel Drvier Manager"};
  }





}



// WEBPACK FOOTER //
// ./src/pages/dvm/home/home.ts